import { TResponse, TTotal } from "@/module/common"
import { TdataListType, TdataMenuType } from '@/module/databank';
import { getDataList, getDataMenu } from "@/api/databank";
import { ref } from "vue";
import { ElLoading } from 'element-plus'
function databanks() {
    const dataMenu = ref<TdataMenuType[]>()
    const gradeList = ref<TdataMenuType[]>()
    const isShow=ref(false)

    // 获取章节接口
    async function GetDataMenu(Id: any, rank: number): Promise<TdataMenuType[]> {
        return new Promise(async (resolve, reject) => {
            let res: TResponse<TdataMenuType[]> = await getDataMenu({ ParentId: Id, ChildrenCount: rank })
            let { Code, Data } = res
            if (Code === 200) {
                if (rank === 1) {
                    dataMenu.value = Data
                    resolve(dataMenu.value)
                } else if (rank === 2) {
                    gradeList.value = Data
                    resolve(gradeList.value)
                }
            }
        })
    }
    // 获取资料库列表
    const GetDataList = async (item: any, Id: number, searchId:number[]) => {
        isShow.value = false
        const loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0)'
        })
        try {
            let res: TResponse<TTotal<TdataListType[]>> = await getDataList({ NodeId: Id, DirectoryIds: searchId, PageIndex: item.PageIndex, PageSize: item.PageSize})
            let { Code, Data } = res
            if (Code === 200) {
                item.list = Data.Data
                item.total = Data.Total
                item.list.forEach((li:any) => {
                    li.ObjType=3
                });
                if (item.list.length===0){
                   isShow.value = true
                }
            }
        } catch (error) {

        }finally{
            loading.close()
        }
    }
    return {
        dataMenu,
        gradeList,
        isShow,
        GetDataList,
        GetDataMenu
    }
}
export default databanks